export default "__VITE_ASSET__CzdknQlA__"